// extracted by mini-css-extract-plugin
export default {"ccBlue":"#2b2bb5","ccTurquoise":"#c2c2c2","ccLightPurple":"#c78fff"};